import React, { Component } from 'react'
import Modal from '../../components/modals/submitModal'
import config from '../../resource/appConfig.js'

const VS = config.reqStatuses.validationSuccessful

class submitLink extends Component {
    render() {
        const triggerId = `submitModalTrigger${this.props.index ?? this.props.PassDataItems.REQUEST_ID}`
        const status = this.props.PassDataItems.REQ_STATUS
        return (
            <div>
                <li className={(status === VS) ? "btn btn-sm btn-secondary borderadd" : null}><strong>
                    <p className="curserhover">
                        <button type="button" id={triggerId} className="linkButton" aria-haspopup="dialog"
                                tabIndex="0">Submit
                        </button>
                    </p>
                </strong>
                </li>
                <Modal triggerId={triggerId} apiAuthHeaders={this.props.apiAuthHeaders}
                       PassDataItems={this.props.PassDataItems} />
            </div>
        )
    }
}

export default submitLink
